import React from 'react';
import { RouterContext } from '../context';
export function useCurrentStateAndParams() {
  const context = React.useContext(RouterContext);
  return {
    params: context.current.params,
    state: context.states[context.current.state]
  };
}
//# sourceMappingURL=useCurrentState.js.map